import { XylemCookies } from "@grindex-common/helpers/XylemCookies.class";
import { apiConfig } from "@grindex-common/helpers/apiConfig";

function init() {
	const xylemCookies = new XylemCookies();
	const $solutions = document.querySelectorAll(".component-genericCardBlock a");
	const cookieName = "xyl-banner_" + apiConfig.apiNode;

	$solutions.forEach(($solution) => {
		$solution.addEventListener("click", () => {
			if (typeof xylemCookies.getCookieValue(cookieName) !== "undefined") {
				xylemCookies.setCookieValue(cookieName, xylemCookies.getCookieValue(cookieName) + ";" + $solution.getAttribute("href"), 14);
			} else {
				xylemCookies.setCookieValue(cookieName, $solution.getAttribute("href"), 14);
			}
		});
	});
}

export default {
	view: "personalized-banner-content",
	init,
};
